export default __webpack_public_path__ + "static/media/ImgHome.87fb5e5b.png";